// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/auctionList/_auctionItemDetail.scss
 ** module id = 1885
 ** module chunks = 0
 **/